var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 0C5.38314 0 0 5.3832 0 12C0 18.6168 5.38314 24 11.9995 24C18.6164 24 24 18.6168 24 12C24 5.3832 18.6164 0 11.9995 0ZM11.9995 22.4262C6.2508 22.4262 1.5738 17.749 1.5738 12C1.5738 6.25098 6.25074 1.57386 11.9995 1.57386C17.749 1.57386 22.4261 6.25104 22.4261 12C22.4261 17.749 17.749 22.4262 11.9995 22.4262Z",
    fill: "#1A86D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7776 7.55801C12.3569 7.55801 12.8268 7.08809 12.8268 6.50867C12.8268 5.92925 12.3569 5.45934 11.7776 5.45934C11.1977 5.45934 10.7283 5.92925 10.7283 6.50867C10.7283 7.08809 11.1977 7.55801 11.7776 7.55801Z",
    fill: "#1A86D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4454 16.7749H12.7873V9.27361C12.7873 8.83903 12.435 8.48665 12.0005 8.48665H10.5548C10.1203 8.48665 9.76807 8.83903 9.76807 9.27361C9.76807 9.70819 10.1203 10.0605 10.5548 10.0605H11.2135V16.7749H10.5548C10.1203 16.7749 9.76807 17.1272 9.76807 17.5618C9.76807 17.9963 10.1203 18.3487 10.5548 18.3487H13.4454C13.8802 18.3487 14.2324 17.9963 14.2324 17.5618C14.2324 17.1272 13.8802 16.7749 13.4454 16.7749Z",
    fill: "#1A86D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.cb93e1882ead69edcd532530441d7fbf.svg";
export { ForwardRef as ReactComponent };